import React from 'react';

function IntegrationProviderIcon({ provider, className = '' }) {
  const classes = `${className} ${provider || 'default'}`.trim();

  if (provider === 'pipedrive') {
    return <span className={classes} aria-hidden="true"><img src={(process.env.PUBLIC_URL || '') + '/images/pipedrive-logo.png'} alt="" /></span>;
  }

  if (provider === 'zoho') {
    return <span className={classes} aria-hidden="true"><img src={`${process.env.PUBLIC_URL || ''}/images/zoho-logo-mark.png`} alt="" /></span>;
  }

  if (provider === 'salesforce') {
    return <span className={classes} aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M10.006 5.415a4.195 4.195 0 0 1 3.045-1.306c1.56 0 2.954.9 3.69 2.205.63-.3 1.35-.45 2.1-.45 2.85 0 5.159 2.34 5.159 5.22s-2.31 5.22-5.176 5.22c-.345 0-.69-.044-1.02-.104a3.75 3.75 0 0 1-3.3 1.95c-.6 0-1.155-.15-1.65-.375A4.314 4.314 0 0 1 8.88 20.4a4.302 4.302 0 0 1-4.05-2.82c-.27.062-.54.076-.825.076C1.801 17.656 0 15.856 0 13.606c0-1.5.811-2.805 2.01-3.51a4.53 4.53 0 0 1-.39-1.846c0-2.58 2.1-4.65 4.65-4.65 1.53 0 2.85.705 3.72 1.8"/></svg></span>;
  }

  if (provider === 'dynamics365') {
    return <span className={classes} aria-hidden="true"><svg viewBox="0 0 24 24"><path fill="#f25022" d="M1 1h10v10H1z"/><path fill="#7fba00" d="M13 1h10v10H13z"/><path fill="#00a4ef" d="M1 13h10v10H1z"/><path fill="#ffb900" d="M13 13h10v10H13z"/></svg></span>;
  }

  if (provider === 'asana') {
    return <span className={classes} aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M18.78 12.653c-2.882 0-5.22 2.336-5.22 5.22s2.338 5.22 5.22 5.22 5.22-2.34 5.22-5.22-2.336-5.22-5.22-5.22zm-13.56 0C2.34 12.653 0 14.99 0 17.873s2.338 5.22 5.22 5.22 5.22-2.338 5.22-5.22-2.336-5.22-5.22-5.22zm12-6.525c0 2.883-2.337 5.22-5.22 5.22-2.882 0-5.22-2.337-5.22-5.22 0-2.88 2.338-5.22 5.22-5.22 2.883 0 5.22 2.34 5.22 5.22z"/></svg></span>;
  }

  if (provider === 'hubspot') {
    return <span className={classes} aria-hidden="true"><svg viewBox="0 0 40 40"><circle cx="12" cy="20" r="5"/><circle cx="29" cy="9" r="4"/><circle cx="30" cy="30" r="4"/><path d="M16 18l10-7M16 22l11 6M12 15V8"/></svg></span>;
  }

  return <span className={classes} aria-hidden="true">{provider ? provider.slice(0, 2).toUpperCase() : 'CRM'}</span>;
}

export default IntegrationProviderIcon;
